module.exports = __webpack_public_path__ + "img/icon-energy-internet-box.ef43daf0.svg";